export const ADD_QUOTE = 'ADD_QUOTE';
export const DELETE_QUOTE = 'DELETE_QUOTE';
export const EDIT_QUOTE = 'EDIT_QUOTE';
export const CLEAR_QUOTES = 'CLEAR_QUOTES';
export const DELETE_SELECTED_QUOTES = 'DELETE_SELECTED_QUOTES';
export const SELECT_QUOTE = 'SELECT_QUOTE';
export const LOAD_QUOTES = 'LOAD_QUOTES';



// WEBPACK FOOTER //
// ./src/constants/index.js